
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center max-w-md p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-5xl font-bold text-red-500 mb-4">404</h1>
        <p className="text-xl text-gray-700 mb-4">Page not found</p>
        <p className="text-gray-600 mb-6">
          The page you are looking for ({location.pathname}) does not exist or has been moved.
        </p>
        <div className="space-y-3">
          <Button 
            asChild 
            className="w-full bg-eco-500 hover:bg-eco-600"
          >
            <Link to="/">Return to Home</Link>
          </Button>
          <Button 
            asChild 
            variant="outline" 
            className="w-full border-eco-500 text-eco-500 hover:bg-eco-500 hover:text-white"
          >
            <Link to="/businesses">Browse Businesses</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
